let _ = t => t,
  _t;
import styledWithTheme from 'foundations-theming/utils';
import { AVATAR_SIZES } from '../../Constants';
import SVGBase from './SVGBase';
export default styledWithTheme(SVGBase)(_t || (_t = _`
  background-size: cover;
  background-position: center;
  display: block;
  text-anchor: middle;
  width: 100%;
  height: ${0};

`), props => props.size && props.size !== AVATAR_SIZES.responsive ? `${AVATAR_SIZES[props.size]}px` : 'inherit');